import React, {forwardRef} from 'react'
import tw from 'twin.macro'
import scaleCanvas from '@/utils/scaleCanvas'

type Props = {
  width: number
  height: number
  draw: (context: CanvasRenderingContext2D) => void
}

const Canvas = forwardRef<HTMLCanvasElement, Props>((
  props,
  ref: React.ForwardedRef<HTMLCanvasElement> | null
) => {
  const {height, width, draw} = props

  React.useEffect(() => {
    if (ref && (ref as React.MutableRefObject<HTMLCanvasElement>).current) {
      const canvas = (ref as React.MutableRefObject<HTMLCanvasElement>).current
      const context = canvas.getContext('2d')
      if (context) {
        scaleCanvas(canvas, context, width, height)
        draw(context)
      }
    }
  })

  return (
    <canvas
      ref={ref}
      height={height}
      width={width}
      css={[
        tw`border border-solid border-brand-600 rounded-sm`,
        'box-shadow: 0px 0px 60px rgba(54, 250, 215, 0.3);'
      ]}

    />
  )
})

Canvas.displayName = 'Canvas'

export default Canvas
